import ITEM from '../../../DOM/LIST/item/ITEM.js';
import { LISTITEMELEMENT } from '../../../../enums/LISTITEMELEMENT.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import DIV from '../../../DOM/div/DIV.js';
// Model Structure
export const liAttr = makeAttrStruct([
    ['name'],
    ['class']
]);
export const liData = makeDataStruct([
    ['text', '']
]);
export const liModel = makeStruct([
    ['attributes', liAttr],
    ['data', liData]
]);
// Simplified Model
export function li(text, className, name) {
    return liModel(liAttr(className, name), liData(text));
}
/** List Item */
export default class LI extends ITEM {
    constructor(node, model) {
        super(node, LISTITEMELEMENT.LI, model);
        this.setInnerHTML(model.data.text);
    }
    addDiv(model) {
        return this.addChild(new DIV(this, model));
    }
}
